// En web no se renderiza ningún ad. Mantenemos la firma para no romper imports.

type Props = {
  inline?: boolean;
};

export function AdBanner(_props: Props) {
  return null;
}
